import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getProductMaster = (payload) => {
  return axios
    .get(`${URL_ORI}/api/ProductMaster/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};


export const getProductMasterMaster = (payload) => {
  return axios
    .get(`${URL_ORI}/api/ProductMaster/searchMaster`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createProductMaster = (payload) => {
  return axios.post(`${URL_ORI}/api/ProductMaster`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createDuplicateProductMaster = (payload) => {
  return axios.post(`${URL_ORI}/api/ProductMaster/duplicate`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdProductMaster = (id) => {
  return axios
    .get(`${URL_ORI}/api/ProductMaster/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateProductMaster = (payload) => {
  return axios.put(`${URL_ORI}/api/ProductMaster`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteProductMaster = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/ProductMaster`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// color mater

export const getColorMaster = (payload) => {
  return axios
    .get(`${URL_ORI}/api/ColorMaster/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createColorMaster = (payload) => {
  return axios.post(`${URL_ORI}/api/ColorMaster`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdColorMaster = (id) => {
  return axios
    .get(`${URL_ORI}/api/ColorMaster/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateColorMaster = (payload) => {
  return axios.put(`${URL_ORI}/api/ColorMaster`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteColorMaster = (payload) => {
  return axios.delete(`${URL_ORI}/api/ColorMaster`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

// ModelMaster

export const getModelMaster = (payload) => {
  return axios
    .get(`${URL_ORI}/api/ModelMaster/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createModelMaster = (payload) => {
  return axios.post(`${URL_ORI}/api/ModelMaster`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdModelMaster = (id) => {
  return axios
    .get(`${URL_ORI}/api/ModelMaster/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateModelMaster = (payload) => {
  return axios.put(`${URL_ORI}/api/ModelMaster`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteModelMaster = (payload) => {
  return axios.delete(`${URL_ORI}/api/ModelMaster`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

